const QuizTypes = {
    SET_SELECTED_QUIZ_ID: 'SET_SELECTED_QUIZ_ID',
    SET_QUIZ_HISTORY: 'SET_QUIZ_HISTORY',
    SET_QUIZ_RESULT: 'SET_QUIZ_RESULT',
    SET_ACTIVE_QUIZ: 'SET_ACTIVE_QUIZ',
    SET_RESET_RESULT: 'SET_RESET_RESULT',
    SET_SHOW_RESULT: 'SET_SHOW_RESULT',
    SET_QUIZ_OPEN: 'SET_QUIZ_OPEN',
    SET_CREATE_QUIZ: 'SET_CREATE_QUIZ',
};

export default QuizTypes;
